module.exports = __webpack_public_path__ + "img/Bolivia.df9a02e1.png";